import * as React from 'react'
import {Route, Routes, Navigate, useNavigate, useLocation, Outlet} from 'react-router-dom';
import {useState, useLayoutEffect} from "react";
import {history} from './_helpers';
import {useSelector} from 'react-redux';
import {Login} from './_login';
import MainDashboardLayout from './Layouts/MainDashboard/MainDashboardLayout';
import AdminDashboardLayout from './Layouts/AdminDashboard/AdminDashboardLayout';
import MainPage from './pages/MainPage';
import AdminPage from './pages/Admin/AdminPage';
import AdminAddForm from './pages/Admin/AdminAdd/AdminAddForm';
import AdminArticle from './pages/Admin/AdminArticle';
import AdminForm from './pages/Admin/AdminForm';
import AdminMenu from './pages/Admin/AdminMenu';
import Form from './pages/Form';
import AllArticles from './pages/SeconLevelPages/AllArticles';
import AllForms from './pages/SeconLevelPages/AllForms';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminAddUser from './pages/Admin/AdminAdd/AdminAddUser/add';
import AdminAlterUser from './pages/Admin/AdminAdd/AdminAddUser/alter';
import AdminAlterForm from './pages/Admin/AdminForm/alterForm';
import AdminAddMenuPoint from './pages/Admin/AdminAdd/AdminAddMenuPoint/add';
import AdminAlterMenuPoint from './pages/Admin/AdminAdd/AdminAddMenuPoint/alter';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/pages/Admin/AdminPage.scss';
import AdminAddArticle from './pages/Admin/AdminAdd/AdminAddArticle';
import AdminMainPage from './pages/Admin/AdminMainPage';
import AdminAlterText from './pages/Admin/AdminMainPage/alter';
import AdminContacts from './pages/Admin/AdminContacts';
import AdminAlterPhone from './pages/Admin/AdminContacts/alterPhone';
import AdminAlterEmail from './pages/Admin/AdminContacts/alterEmail';

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  const [appState, setAppState] = useState({
       loading: false,
       repos: null,
  });

  function PrivateOutlet() {
    const authUser = useSelector(x => x.auth.user);
    return authUser ? <Outlet/> : <Navigate to="/login"/>;
  }

  return (
    <Routes>
        <Route exact path="/" element={<MainDashboardLayout/>}>
          <Route index element={<MainPage/>}/>
          <Route exact path="forms" element={<AllForms/>}/>
          <Route exact path="forms/:currentId" element={<Form/>}/>
          <Route path="info" element={<AllArticles/>}/>
        </Route> 
        <Route exact path="/login" element={<Login/>}/>
        <Route exact path="/admin" element = {<PrivateOutlet/>}>
          <Route path="home" element={<AdminDashboardLayout/>}>
            <Route index element={<AdminPage/>}/>
            <Route exact path="menu" element={<AdminMenu/>}/>
            <Route exact path="menu/newpoint" element={<AdminAddMenuPoint/>}/>
            <Route exact path="menu/:pointId" element={<AdminAlterMenuPoint/>}/>
            <Route exact path="mainpage" element={<AdminMainPage/>}/>
            <Route exact path="mainpage/:textId" element={<AdminAlterText/>}/>
            <Route exact path="contacts" element={<AdminContacts/>}/>
            <Route exact path="contacts/email/:emailId" element={<AdminAlterEmail/>}/>
            <Route exact path="contacts/phone/:phoneId" element={<AdminAlterPhone/>}/>
            <Route exact path="form" element={<AdminForm/>}/>
            <Route exact path="form/newform" element={<AdminAddForm/>}/>
            <Route exact path="form/alter/:formId" element={<AdminAlterForm/>}/>
            <Route exact path="article/newarticles" element={<AdminAddArticle/>}/>
            <Route exact path="article" element={<AdminArticle/>}/>
            <Route exact path="users/newuser" element={<AdminAddUser/>}/>
            <Route exact path="users/:userId" element={<AdminAlterUser/>}/>
            <Route exact path="users" element={<AdminUsers/>}/>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/"/>}/>
    </Routes>
  );
}

export default App;
